import type { SVGProps } from "react";
const SvgAiBrain01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M5.833 3.75a2.5 2.5 0 0 0-2.139 3.795 2.5 2.5 0 0 0 0 4.91m2.14-8.705a2.083 2.083 0 0 1 4.166 0v12.5a2.083 2.083 0 1 1-4.167 0 2.5 2.5 0 0 1-2.139-3.795m2.14-8.705c0 .682.327 1.287.833 1.667m-2.973 7.038c.297-.49.758-.869 1.306-1.063"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M14.167 16.25a2.5 2.5 0 0 0 2.139-3.795 2.5 2.5 0 0 0 0-4.91m-2.14 8.705a2.083 2.083 0 0 1-4.166 0V3.75a2.083 2.083 0 0 1 4.167 0 2.5 2.5 0 0 1 2.139 3.795m-2.14 8.705a2.08 2.08 0 0 0-.833-1.667m2.973-7.038c-.297.49-.758.869-1.306 1.063"
    />
  </svg>
);
export default SvgAiBrain01;
